import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { DecompositionTreeGraph } from "@ant-design/graphs";
import PlanInfoModal from "../modal/PlanInfoModal";
import UnitPlansInfoModal from "../modal/UnitPlansInfoModal";
import GetUnitsTreePerformanceApi from "../../api/units/GetUnitsTreePerformanceApi";
import { useSelector } from "react-redux";
import { GetOrganizationLevelsApi } from "../../api/org-levels/GetOrganizationLevelsApi";
import PageLoader from "../sub/PageLoader";

const UnitsTree = () => {
  const [canStart, setCanStart] = useState(false);
  const [infoModal, setInfoModal] = useState(false);
  const [data, setData] = useState([]);
  const [levels, setLevels] = useState();
  const [unitId, setUnitId] = useState("");
  const perfCycleState = useSelector((state) => state.perfCycleState.value);
  const positionState = useSelector((state) => state.positionState.value);

  useEffect(() => {
    getTreeData();
    getOrganizationLevels();
  }, []);

  async function getTreeData() {
    const apiResponse = await GetUnitsTreePerformanceApi(
      perfCycleState.id,
      positionState.id
    );
    if (apiResponse.message === "success") {
      setData(apiResponse.units);
      setCanStart(true);
    }
  }

  async function getOrganizationLevels() {
    const apiResponse = await GetOrganizationLevelsApi();
    if (apiResponse.message === "success") {
      setLevels(apiResponse.levels);
    }
  }

  function getNodeColor(node) {
    let nodeColor = "#91d5ff";
    levels?.forEach((level) => {
      if (level.name === node.level) {
        nodeColor = level.color;
      }
    });
    return nodeColor;
  }

  const config = {
    data,
    nodeCfg: {
      style: (node) => {
        return {
          stroke: getNodeColor(node),
          cursor: "pointer",
        };
      },
      label: {
        style: {
          cursor: "pointer",
        },
      },
      title: {
        containerStyle: (node) => {
          return {
            fill: getNodeColor(node),
            cursor: "pointer",
          };
        },
      },
      size: [180, 50],
    },
    edgeCfg: {
      type: "polyline",
    },
    behaviors: ["drag-canvas", "zoom-canvas", "drag-node"],
    autoFit: false,
  };

  return canStart ? (
    <>
      <div className="border">
        <DecompositionTreeGraph
          {...config}
          onReady={(graph) => {
            graph.on("node:click", (evt) => {
              setInfoModal(true);
              setUnitId(evt.item._cfg.id);
            });
          }}
        />
      </div>
      <UnitPlansInfoModal
        visible={infoModal}
        handleCancel={() => setInfoModal(false)}
        unitId={unitId}
      />
    </>
  ) : (
    <PageLoader />
  );
};

export default UnitsTree;
